import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import PikiLogo from "./PikiLogo";

const links = [
  { to: "/", label: "Home", id: "home" },
  { to: "/fleet", label: "Our Fleet", id: "fleet" },
  { to: "/rates", label: "Rates", id: "rates" },
  { to: "/about", label: "About", id: "about" },
  { to: "/faq", label: "FAQ", id: "faq" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#050505]/85 border-b border-[#2E2E2E]/80">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10 h-28 sm:h-32 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center py-2 pr-6" data-testid="navbar-brand-logo">
          <PikiLogo className="h-20 sm:h-24 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.id}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-lg text-[13px] font-semibold uppercase tracking-[0.08em] transition-colors ${
                  isActive ? "text-[#D9A62E]" : "text-[#D4D4D4] hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => nav("/book")}
            className="hidden sm:inline-flex piki-gold-btn text-sm"
            data-testid="nav-cta-book-btn"
          >
            Book Now
          </button>
          <Link
            to="/admin/login"
            data-testid="nav-admin-login-link"
            className="hidden"
            aria-hidden="true"
            tabIndex={-1}
          >
            Admin
          </Link>
          <button className="lg:hidden text-white p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#2E2E2E] bg-[#050505]/98 backdrop-blur-xl">
          <div className="px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.id}`}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-lg text-base font-medium ${isActive ? "bg-[#171717] text-[#D9A62E]" : "text-[#D4D4D4]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
